import React from 'react';
import { Icon } from '../components/ui';
import TenantSignupModal from '../components/TenantSignupModal';
import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import ModulesGrid from '../components/landing/ModulesGrid';
import TestimonialsCarousel from '../components/landing/TestimonialsCarousel';
import PricingSection from '../components/landing/PricingSection';
import FaqSection from '../components/landing/FaqSection';
import NewsletterSection from '../components/landing/NewsletterSection';
import Footer from '../components/landing/Footer';
import LoginOverlay from '../components/landing/LoginOverlay';

export default function Landing() {
  const [openSignup, setOpenSignup] = React.useState(false);
  const [showLogin, setShowLogin] = React.useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-gray-950 to-slate-900 text-slate-200 font-sans overflow-x-hidden relative">
      {/* Background effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-purple-600/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAwIiBjeT0iMTAwIiByPSIxIiBmaWxsPSIjMTUxODJlIiBmaWxsLW9wYWNpdHk9IjAuMSIvPjwvc3ZnPg==')] opacity-20" />
      </div>

      {showLogin && <LoginOverlay onClose={() => setShowLogin(false)} />}

      <Navbar onLogin={() => setShowLogin(!showLogin)} onSignup={() => setOpenSignup(true)} showLogin={showLogin} />

      <main className="relative z-10 px-6 lg:px-8 max-w-7xl mx-auto">
        <HeroSection onSignup={() => setOpenSignup(true)} />
        <ModulesGrid />
        <TestimonialsCarousel />
        <PricingSection onSignup={() => setOpenSignup(true)} />
        <FaqSection />
        <NewsletterSection />
        <Footer />
      </main>

      {/* Floating CTA */}
      <div className="fixed bottom-8 right-8 z-50">
        <button
          onClick={() => setOpenSignup(true)}
          className="px-8 py-4 rounded-2xl bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-bold shadow-2xl shadow-indigo-500/30 hover:shadow-indigo-500/50 transition-all duration-300 hover:scale-105 group flex items-center gap-3 animate-bounce"
          style={{ animationDuration: '2s' }}
        >
          <span>Essai gratuit</span>
          <Icon name="IconPlus" size={20} className="group-hover:rotate-90 transition-transform duration-300" />
        </button>
      </div>

      {openSignup && <TenantSignupModal onClose={() => setOpenSignup(false)} />}
    </div>
  );
}
